/* eslint-disable no-useless-escape */
import React from "react";
import { Menu, Dropdown, Tooltip } from "antd";
import moment from "moment-timezone";

import {
  ActionsButtonIcon,
  smsIcon,
  callIcon,
  CopyIcon,
  autoIcon,
  emailIcon,
  phoneIconSmall,
  smsIconSmall,
  emailIconSmall,
  rcsIconSmall,
  rcsIcon,
} from "../assets/svg";

const broadcastTransactionCompleteStatus = {
  awaiting: 0, // When uploaded
  inProgress: 1,
  completed: 2,
  discarded: 3,
  killed: 4,
};

export const RESEND_DELAY_IN_SECONDS = 60;
export const ALLOWED_OTP_COUNTS = 3;
let envEhrName = process.env.REACT_APP_EHR_NAME;
let EHR_NAME;

// Get the current URL
const currentUrl = new URL(window.location.href).toString().toLowerCase();

// Determine EHR_NAME based on the current URL or fallback to env variable
const determineEhrName = (url) => {
  if (!url || typeof url !== "string") return envEhrName || "epic";
  if (url.includes("nextgenmessaging")) return "nextgen";
  if (url.includes("cerner")) return "cerner";
  if (url.includes("portal-pe") || url.includes("portal.pe"))
    return "practice-edition";
  if (url.includes("veradigm")) return "veradigm";
  return envEhrName || "epic"; // Fallback to env variable
};

EHR_NAME = determineEhrName(currentUrl);

export { EHR_NAME };

// Boolean flags based on resolved EHR_NAME
export const NEXTGEN_EHR_WHITELABEL =
  EHR_NAME?.toLocaleLowerCase() === "nextgen";
export const CERNER_EHR_WHITELABEL = EHR_NAME?.toLocaleLowerCase() === "cerner";
export const EPIC_EHR_WHITELABEL = EHR_NAME?.toLocaleLowerCase() === "epic";
export const VERADIGM_EHR_WHITELABEL =
  EHR_NAME?.toLocaleLowerCase() === "veradigm";
export const PRACTICE_EDITION_WHITELABEL =
  EHR_NAME?.toLocaleLowerCase() === "practice-edition";

export const DISABLE_SECURED_CHAT = false;
export const securedSessionLink = process.env.REACT_APP_LINK_SHORTNER_URL;
// Move credentials to backend for production.
let BEE_CLIENT_ID = "7a0fb46a-b468-4489-8cb1-a28fe82991a0";
let BEE_CLIENT_SECRET = process.env.REACT_APP_BEE_CLIENT_SECRET;
if (process.env.NODE_ENV === "prod") {
  BEE_CLIENT_ID = "c6e7b20c-3e3e-4b47-a9ef-c72adade2404";
  BEE_CLIENT_SECRET = process.env.REACT_APP_BEE_CLIENT_SECRET_PROD;
}

export { BEE_CLIENT_ID, BEE_CLIENT_SECRET };

export const BEE_BASE_TEMPLATE = "https://rsrc.getbee.io/api/templates/m-bee";

const getUrls = () => {
  if (process.env.REACT_APP_ENV === "dev") {
    return {
      // baseUrl: 'http://localhost:4000', // 'https://portal-test-backend.simplify.health',
      // baseUrl: 'https://portal-uat-backend.myhousecallspro.com',
      aspariaBackend: "http://localhost:5000/",
      // aspariaBackend: "https://livechat-backend-uat.myhousecallspro.com/",
      // nextGenBaseUrl: 'https://nativeapi.nextgen.com/nga-native-api/'
    };
  } else if (process.env.REACT_APP_ENV === "demo") {
    return {
      aspariaBackend: "https://livechat-backend-demo.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "prod") {
    return {
      aspariaBackend: "https://service-livechat-backend.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "stage") {
    return {
      // baseUrl: 'https://portal-stage-backend.simplify.health',
      aspariaBackend: "https://textingchat-backend-stage.simplify.health/",
      // nextGenBaseUrl: 'https://nativeapi.nextgen.com/nga-native-api/'
    };
  } else if (process.env.REACT_APP_ENV === "testserver") {
    return {
      // baseUrl: 'https://portal-stage-backend.simplify.health',
      aspariaBackend: "https://textingchat-backend-test.simplify.health/",
    };
  }
  // else if (process.env.REACT_APP_ENV === 'demo') {
  //   return {
  //     // baseUrl: 'https://portal-stage-backend.simplify.health',
  //     aspariaBackend: 'https://livechat-backend-demo.myhousecallspro.com/',
  //   };
  // }
  else if (process.env.REACT_APP_ENV === "uat") {
    return {
      // baseUrl: 'https://portal-stage-backend.simplify.health',
      aspariaBackend: "https://livechat-backend-uat.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "qa") {
    return {
      aspariaBackend: "https://livechat-backend-qa.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "beta") {
    return {
      // baseUrl: 'https://portal-stage-backend.simplify.health',
      aspariaBackend: "https://livechat-backend-beta.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "nextgen-demo") {
    return {
      aspariaBackend: "https://livechat-backend-demo.nextgenmessaging.com/",
    };
  } else if (process.env.REACT_APP_ENV === "nextgen-uat") {
    return {
      aspariaBackend: "https://livechat-backend-uat.nextgenmessaging.com/",
    };
  } else if (process.env.REACT_APP_ENV === "nextgen-beta") {
    return {
      aspariaBackend: "https://livechat-backend-beta.nextgenmessaging.com/",
    };
  } else if (process.env.REACT_APP_ENV === "nextgen-prod") {
    return {
      aspariaBackend: "https://service-livechat-backend.nextgenmessaging.com/",
    };
  } else if (process.env.REACT_APP_ENV === "cerner-dev") {
    return {
      aspariaBackend: "https://livechat-backend-demo.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "cerner-demo") {
    return {
      aspariaBackend:
        "https://livechat-cerner-backend-demo.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "cerner-uat") {
    return {
      aspariaBackend:
        "https://livechat-cerner-uat-backend.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "cerner-beta") {
    return {
      aspariaBackend:
        "https://livechat-cerner-beta-backend.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "cerner-prod") {
    return {
      aspariaBackend:
        "https://service-cerner-livechat-backend.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "pe-demo") {
    return {
      aspariaBackend: "https://livechat-pe-backend-demo.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "pe-uat") {
    return {
      aspariaBackend: "https://livechat-pe-backend-uat.myhousecallspro.com/",
    };
  } else if (process.env.REACT_APP_ENV === "pe-beta") {
    return {
      aspariaBackend: "https://livechat-backend-beta.pe.televox.com/",
    };
  } else if (process.env.REACT_APP_ENV === "pe-prod") {
    return {
      aspariaBackend: "https://livechat-backend.pe.televox.com/",
    };
  } else if (process.env.REACT_APP_ENV === "servicedemo") {
    return {
      aspariaBackend:
        "https://livechat-backend-service-demo.myhousecallspro.com/",
    };
  }
};

export const urls = getUrls();
// export const urls = { aspariaBackend: '' };
export const SET_POPUP = "SET_POPUP";
export const UNREAD_MSG = "UNREAD_MSG";
export const NOTIFICATION_ALERT = "NOTIFICATION_ALERT";
export const messageTypes = {
  custom: "custom",
  template: "template",
};

export const SECRET_KEY = "8bDaygMTAAAAANokdEEial";
export const IV_KEY = "mHGFxEbntdEienLyANoi.e";

export const patientBulkUploadCSVSampleData = [
  [
    "firstName|lastName|middleName|cellPhone|dateOfBirth|gender|socialSecurityNumber|medicalRecordNumber|ehrPatientId|email",
  ],
];
export const patientBulkUploadCommaSeparatedSampleData = [
  [
    "firstName,lastName,middleName,cellPhone,dateOfBirth,gender,socialSecurityNumber,medicalRecordNumber,ehrPatientId,email",
  ],
];
export const emailAndPhoneRegex = /^((\s?(?:[\+]?\(?\d{0,3}\)?[\s]?)?\-?\(?\d{3,}\)?[\s-]?\(?\d{3,}\)?[\s-]?\(?\d{4,}\)?\,?){0,50})$/;
export const newLineRegex = /\n/g;
let domain = ".myhousecallspro.com";
if (process.env.REACT_APP_ENV?.includes("nextgen")) {
  domain = ".nextgenmessaging.com";
}
export const LIVECHAT_DOMAIN = domain;
export const hcpPortalUrlRegex = `https?://([a-z0-9-]+)*${LIVECHAT_DOMAIN}`;

export const patientReportsColumns = (downloadFiles, downloading) => {
  return [
    {
      title: "Patient",
      dataIndex: "patientCellPhoneNo",
      key: "patientCellPhoneNo",
      sorter: true,
      className: "Patient-column",
      filter: "patient",
      dataKey: "cellPhone",
      width: "20rem",
    },
    {
      title: "Upload Status",
      dataIndex: "fileStatus",
      key: "fileStatus",
      sorter: true,
      filter: "uploadStatus",
      dataKey: "fileStatus",
      width: "20rem",
    },
    {
      title: "Time Elapsed",
      dataIndex: "timeElapsed",
      key: "timeElapsed",
      sorter: true,
      filter: false,
      width: "20rem",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      filter: false,
      className: "table-actions",
      width: "20rem",
      render: (text, record) => {
        const downloadInProgress =
          downloading[`${record.patientId}.zip`] || false;
        return record.fileStatus === "uploaded" ? (
          <span
            className="table-icons-group"
            onClick={() =>
              downloadFiles(record.patientId, `${record.patientId}.zip`, record)
            }
          >
            <span
              className={`download-link ${
                downloadInProgress ? "disabled" : ""
              }`}
            >
              Download File
            </span>
          </span>
        ) : (
          <span className="">No patient files to download</span>
        );
      },
    },
  ];
};
export const broadcastReportsColumns = (
  downloadFiles,
  handlePopUp,
  copyToClipboard,
  loggedinUser,
) => {
  return [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      ellipsis: true,
      width: "4rem",
      filter: false,
      className: "table-actions",
      render: (text, record) => (
        <>
          {record.convoType === "sms" ? (
            <Tooltip title="SMS">
              <span className="table-icons-group">{smsIcon}</span>
            </Tooltip>
          ) : record.convoType === "ivr" ? (
            <Tooltip title="IVR">
              <span className="table-icons-group">{callIcon}</span>
            </Tooltip>
          ) : record.convoType === "email" ? (
            <Tooltip title="Email">
              <span className="table-icons-group">{emailIcon}</span>
            </Tooltip>
          ) : record.convoType === "rcs" ? (
            <Tooltip title="RCS">
              <span className="table-icons-group">{rcsIcon}</span>
            </Tooltip>
          ) : (
            <Tooltip title="Auto">
              <span className="table-icons-group">{autoIcon}</span>)
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      sorter: true,
      width: 200,
      ellipsis: true,
      className: "copy-fileName-column",
      render: (text, record) => (
        <div className="copy-clipboard">
          <span title={record.fileName}>{record.fileName}</span>
          {record?.fileName && (
            <Tooltip title="Copy File Name">
              <span
                role="button"
                onClick={() => copyToClipboard(record.fileName)}
              >
                {CopyIcon}
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: "Custom File Title",
      dataIndex: "fileNickName",
      key: "fileNickName",
      sorter: true,
      width: 200,
      ellipsis: true,
      className: "Patient-column",
    },
    {
      title: "Broadcast Type",
      dataIndex: "broadcastType",
      key: "broadcastType",
      sorter: true,
      width: 200,
    },
    {
      title: "Upload Time ",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      width: 200,
      filter: false,
    },
    {
      title: "Scheduled Time ",
      dataIndex: "scheduledDateTime",
      key: "scheduledDateTime",
      sorter: true,
      width: 200,
      filter: false,
    },
    ...(!CERNER_EHR_WHITELABEL
      ? [
          {
            title: "Multi-Lang",
            dataIndex: "isMultiLang",
            key: "isMultiLang",
            sorter: true,
            width: 120,
            filter: false,
            render: (value) => {
              return value ? "Yes" : "No";
            },
          },
        ]
      : []),
    {
      title: "Failed",
      dataIndex: "systemFailure",
      key: "systemFailure",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Unreachable",
      dataIndex: "unreachable",
      key: "unreachable",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Contacted",
      dataIndex: "delivered",
      key: "delivered",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Queued",
      dataIndex: "queued",
      key: "queued",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Pending",
      dataIndex: "pending",
      key: "pending",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      sorter: true,
      width: 120,
      filter: false,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: false,
      filter: false,
      width: 100,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      ellipsis: true,
      width: "4rem",
      filter: false,
      className: "table-actions",
      render: (text, record) => (
        <Dropdown
          overlayClassName="custom-icons-dropdown"
          overlay={() => menu(record, downloadFiles, handlePopUp, loggedinUser)}
          trigger={["click"]}
        >
          <span className="table-icons-group">
            <ActionsButtonIcon />
          </span>
        </Dropdown>
      ),
    },
  ];
};

function convertUTCToTimeZone(datetimeStr, targetZone) {
  const utcMoment = moment.tz(datetimeStr, "UTC");

  let zone;
  if (targetZone === "EST") {
    zone = "America/New_York";
  } else if (targetZone === "PST") {
    zone = "America/Los_Angeles";
  } else if (targetZone === "CST") {
    zone = "America/Chicago";
  } else if (targetZone === "MST") {
    zone = "America/Denver";
  } else if (targetZone === "ARIZONA-MST") {
    zone = "US/Arizona";
  } else if (targetZone === "AKST") {
    zone = "US/Alaska";
  } else if (targetZone === "HST") {
    zone = "US/Hawaii";
  } else if (targetZone === "UTC") {
    return datetimeStr;
  }

  const convertedDate = utcMoment
    .clone()
    .tz(zone)
    .format("MM/DD/YYYY HH:mm");
  return convertedDate;
}

export const messageLogColumns = (copyToClipboard, dateFilter) => {
  return [
    {
      title: "Patient Contact",
      dataIndex: "patientContact",
      key: "patientContact",
      sorter: false,
      width: 200,
    },

    {
      title: "Conversation Type",
      dataIndex: "conversationType",
      key: "conversationType",
      sorter: true,
      width: 200,
      ellipsis: true,
      render: (text, record) => {
        return (
          <div className="convo-flex">
            {record?.conversationType === "ivr"
              ? phoneIconSmall
              : record?.conversationType === "sms"
                ? smsIconSmall
                : record?.conversationType === "email"
                  ? emailIconSmall
                  : record?.conversationType === "rcs"
                    ? rcsIconSmall
                    : ""}{" "}
            {record?.conversationType || ""}
          </div>
        );
      },
    },
    {
      title: "Message Sent",
      dataIndex: "messageSent",
      key: "messageSent",
      sorter: true,
      width: 200,
      filter: false,
      render: (text, record) => {
        return !isNaN(new Date(record?.messageSent).getTime())
          ? convertUTCToTimeZone(
              record?.messageSent,
              dateFilter?.timeZone?.name,
            )
          : record?.messageSent;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      width: 200,
      render: (text, record) => {
        return (
          <div className={`status-box`}>
            {record?.status?.charAt(0).toUpperCase() + record?.status?.slice(1)}
          </div>
        );
      },
    },
    {
      title: "Language",
      dataIndex: "translatedLanguage",
      key: "translatedLanguage",
      sorter: true,
      width: 180,
      ellipsis: true,
      render: (value: string | null) => {
      if (!value) return "-";
       return value;
      },
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      sorter: false,
      width: 300,
      ellipsis: true,
      filter: false,
      render: (text, record) => {
        return (
          <div className="message-box" title={record?.message}>
            <div className="message-text">{record?.message}</div>
            {record?.message && (
              <div className="tooltip-icon">
                <Tooltip title="Copy Message">
                  <span
                    role="button"
                    onClick={() => copyToClipboard(record?.message)}
                  >
                    {CopyIcon}
                  </span>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
  ];
};

const menu = (record, downloadFiles, handlePopUp, loggedinUser) => {
  // disable all options for BA except download
  const { roles = {}, lcUser } = loggedinUser || {};

  let { roleKey } = roles;
  if (lcUser?.roles) roleKey = lcUser.roles.roleKey;
  const isBARole = roleKey === "BA";

  const disableKill =
    record.type === "cancelled" ||
    record.type === "onDemand-sched" ||
    record.completeStatus === broadcastTransactionCompleteStatus.killed ||
    record.completeStatus === broadcastTransactionCompleteStatus.completed ||
    isBARole
      ? true
      : false;

  const disableButton =
    record.type === "cancelled" ||
    record.type === "onDemand-sched" ||
    record.completeStatus === broadcastTransactionCompleteStatus.killed ||
    record.completeStatus === broadcastTransactionCompleteStatus.completed ||
    isBARole
      ? "disable-button"
      : "remove-button";

  return (
    <Menu>
      <>
        <Menu.Item
          key="0"
          disabled={record.broadcastType === "cancelled" ? true : false}
          onClick={() =>
            downloadFiles(
              record.broadcastTransactionId,
              record.fileName,
              record.convoType,
            )
          }
        >
          <span
            className={`actions-dropdown-title ${
              record.broadcastType === "cancelled" ? "disable-button" : ""
            }`}
          >
            Download Report
          </span>
        </Menu.Item>

        <Menu.Item
          key="1"
          disabled={
            record.broadcastType === "onDemand" ||
            record.broadcastType === "cancelled" ||
            isBARole
              ? true
              : false
          }
          onClick={() => {
            handlePopUp("edit", record);
          }}
        >
          <span
            className={`actions-dropdown-title ${
              record.broadcastType === "onDemand" ||
              record.broadcastType === "cancelled" ||
              isBARole
                ? "disable-button"
                : ""
            }`}
          >
            Edit Broadcast
          </span>
        </Menu.Item>

        <Menu.Item
          key="2"
          disabled={
            record.broadcastType === "onDemand" ||
            record.broadcastType === "cancelled" ||
            isBARole
              ? true
              : false
          }
          onClick={() => {
            handlePopUp("send", record);
          }}
        >
          <span
            className={`actions-dropdown-title ${
              record.broadcastType === "onDemand" ||
              record.broadcastType === "cancelled" ||
              isBARole
                ? "disable-button"
                : ""
            }`}
          >
            Send Now
          </span>
        </Menu.Item>
        <Menu.Item
          key="3"
          disabled={
            record.broadcastType === "onDemand" ||
            record.broadcastType === "cancelled" ||
            isBARole
              ? true
              : false
          }
          onClick={() => {
            handlePopUp("delete", record);
          }}
        >
          <span
            className={`actions-dropdown-title ${
              record.broadcastType === "onDemand" ||
              record.broadcastType === "cancelled" ||
              isBARole
                ? "disable-button"
                : "remove-button"
            }`}
          >
            Cancel Broadcast
          </span>
        </Menu.Item>
        <Menu.Item
          key="4"
          disabled={disableKill}
          onClick={() => {
            handlePopUp("killed", record);
          }}
        >
          <span className={`actions-dropdown-title ${disableButton}`}>
            Stop Broadcast
          </span>
        </Menu.Item>
      </>
    </Menu>
  );
};

export const timezoneList = [
  { value: "America/Chicago", name: "US/Central" },
  { value: "America/Montreal", name: "US/Eastern" },
  { value: "America/Denver", name: "US/Mountain" },
  { value: "America/Los_Angeles", name: "US/Pacific" },
  { value: "US/Arizona", name: "US/Arizona" },
  { value: "US/Alaska", name: "US/Alaska" },
  { value: "US/Hawaii", name: "US/Hawaii" },
];
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const usernameRegex = /^[a-zA-Z0-9-_]+$/;
export const specialCharRegex = /[`!@#$%^&*_\=\[\]{};':"\\|,<>\/?~]/;
export const searchRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
export const NumericRegex = /^[0-9]+$/;

export const quickReplyMenu = (
  getQuickReplyList,
  handleQuickReply,
  mngQckRplyAccess,
) => {
  return (
    <Menu>
      <>
        <Menu.Item
          key="0"
          disabled={!mngQckRplyAccess}
          onClick={handleQuickReply}
        >
          <span
            className={`actions-dropdown-title ${
              mngQckRplyAccess ? "" : "disable-button"
            }`}
          >
            Manage Quick Reply
          </span>
        </Menu.Item>

        <Menu.Item key="1" onClick={getQuickReplyList}>
          <span className="actions-dropdown-title ">Refresh List</span>
        </Menu.Item>
      </>
    </Menu>
  );
};

export const mobileOptionsMenu = (transferNumber, releaseNumber) => {
  return (
    <Menu>
      <>
        <Menu.Item key="1">
          <span className="actions-dropdown-title" onClick={transferNumber}>
            Transfer Number
          </span>
        </Menu.Item>

        <Menu.Item key="2">
          <span className="actions-dropdown-title " onClick={releaseNumber}>
            Release Number
          </span>
        </Menu.Item>
      </>
    </Menu>
  );
};

export const checkUrl = (user, history) => {
  const { liveChatAccess, liveAgentAccess, broadcastAccess } = user;

  if (liveChatAccess) {
    history.push("/chat");
  } else if (liveAgentAccess) {
    history.push("/chat-agent");
  } else if (broadcastAccess) {
    history.push("/broadcast");
  } else if (!liveAgentAccess && !broadcastAccess) {
    history.push("/chat");
  } else if (!liveChatAccess && !broadcastAccess) {
    history.push("/chat-agent");
  } else if (!liveChatAccess && !liveAgentAccess) {
    history.push("/broadcast");
  }
};

export const testTabsData = {
  id: 9,
  claimedUserId: "",
  ehr: "athena",
  practiceId: 195900,
  userName: "",
  firstName: null,
  lastName: null,
  middleName: null,
  homePhone: 6502469353,
  dateOfBirth: null,
  sex: null,
  socialSecurityNumber: null,
  personNumber: null,
  medicalRecordNumber: 5678,
  active: false,
  createdAt: "2019-12-18T12:01:41.000Z",
  updatedAt: "2019-12-26T05:37:06.000Z",
  patientId: null,
  messageTimeStamp: "2019-12-26T05:37:06.000Z",
  type: "nextgen",
  count: 0,
};

export const MODALITY_TYPES = [
  { label: "SMS", value: "sms" },
  { label: "IVR", value: "ivr" },
  { label: "Email", value: "email" },
  { label: "Auto", value: "auto" },
  { label: "RCS", value: "rcs" },
];

export const acceptedAudio = ["mp3", "ogg"];
export const uploadFileSize = 8388608;
export const uploadFileRowsLength = 80000;
export const uploadAudioFileSize = 4000000;
export const NEXTGEN_EHR = "nextgen";
export const DROPDOWN_SIZE = 10;
export const ATHENA_EHR = "athena";
export const EPIC_EHR = "epic";
export const AGENT_TYPING = "AGENT_TYPING";
export const TABLET_SMALL = 900;
export const MOBILE_WIDTH = 800;
export const SMALL_MOBILE_WIDTH = 480;
export const TABLE_PAGE_SIZE = 15;
export const rangeList = [
  {
    key: "thisWeek",
    value: "This Week",
  },
  {
    key: "thisMonth",
    value: "This Month",
  },
  {
    key: "last7days",
    value: "Last 7 Days",
  },
  {
    key: "last15days",
    value: "Last 15 Days",
  },
  {
    key: "last30days",
    value: "Last 30 Days",
  },
  {
    key: "last3months",
    value: "Last 3 Months",
  },
  {
    key: "all",
    value: "All",
  },
  {
    key: "random",
    value: "Custom",
  },
];

export const IDLE_TIMEOUT = {
  IDLE_DURATION_IN_MINUTES: 60,
  WARNING_BEFORE_IN_MINUTES: 5,
};

export const TOKEN_NAMES = {
  FE: "lc-token-fe",
  LC: "lc-token",
  OTP: "lc-otpToken",
  MS: "ms-lc-token",
  SSO: "sso-lc-token",
  MS_LOGIN: "ms-lc-login",
  TOKEN: "token",
  RESEND: "resendOTPToken",
};

export const TOKEN_EXPIRY = "token_expiry";

export const SHOW_AS_OPTIONS = [
  {
    label: "Custom Template",
    value: "custom",
  },
  {
    label: "Default Template",
    value: "default",
  },
];

export const FORMATTED_STATUS_LIST = [
  {
    title: "Confirmed",
    key: "confirmed",
    value: "confirmed",
  },
  {
    title: "Cancelled",
    key: "cancelled",
    value: "cancelled",
  },
  {
    title: "Rescheduled",
    key: "reschedule",
    value: "reschedule",
  },
  {
    title: "No Response",
    key: "no-response",
    value: "no-response",
  },
];

export const DEBOUNCE_TIME = 450;

export const CONVO_TYPE = {
  SMS: "sms",
  IVR: "ivr",
  EMAIL: "email",
  AUTO: "auto",
  RCS: "rcs",
};

export const DATE_TIME_FORMAT = {
  MM_DD_YYYY_HH_mm: "MM-DD-YYYY HH:mm",
};

export const LANGUAGE_FULLFORMS = {
  en: "English",
  ru: "Russian",
  vi: "Vietnamese",
  es: "Spanish",
  zh: "Chinese (Simplified)",
  /*
    af: "Afrikaans", 
    ar: "Arabic",
    az: "Azerbaijani",
    bg: "Bulgarian",
    bn: "Bengali",
    ca: "Catalan",
    cs: "Czech",
    da: "Danish",
    de: "German",
    el: "Greek",
    eo: "Esperanto",
    et: "Estonian",
    eu: "Basque",
    fa: "Persian",
    fi: "Finnish",
    fr: "French",
    ga: "Irish",
    gl: "Galician",
    he: "Hebrew",
    hi: "Hindi",
    hu: "Hungarian",
    id: "Indonesian",
    it: "Italian",
    ja: "Japanese",
    ko: "Korean",
    ky: "Kyrgyz",
    lt: "Lithuanian",
    lv: "Latvian",
    ms: "Malay",
    nb: "Norwegian",
    nl: "Dutch",
    pb: "Portuguese (Brazil)",
    pl: "Polish",
    pt: "Portuguese",
    ro: "Romanian",
    sk: "Slovak",
    sl: "Slovenian",
    sq: "Albanian",
    sv: "Swedish",
    th: "Thai",
    tl: "Tagalog",
    tr: "Turkish",
    uk: "Ukrainian",
    ur: "Urdu",
    zt: "Chinese (Traditional)",
  */
};

export const NO_SHOW_LABEL = 'No Show';
